import React, { useEffect, useMemo, useState } from "react";
import Parser from "rss-parser";
import UserStore from "../stores/UserStore";
import { AnimatedSlider } from "./AnimatedSlider";

type Slide = {
  title: string;
  description: string;
  button: string;
  image: string;
  link: string;
};

const feedUrlForMandant = (mandantId: number) =>
  mandantId === 2
    ? "https://intern.altbayerischer.de/feed/"
    : "https://intern.aktuell-verein.de/feed/";

const fallbackSlides = (mandantId: number): Slide[] => {
  const base: Slide = {
    title: "Neues WebPortal ab 15.11. – Vorstellungswebinar",
    button: "Mehr erfahren",
    description: "",
    image:
      "https://www.aktuell-verein.de/wp-content/uploads/2016/09/iStock_70091675_1086x724-768x512.jpg",
    link:
      mandantId === 2
        ? "https://intern.altbayerischer.de/neues-webportal-ab-15-11-vorstellungswebinar/"
        : "https://intern.aktuell-verein.de/neues-webportal-ab-15-11-vorstellungswebinar/",
  };
  return [base];
};

const sanitize = (htmlOrText: string) => htmlOrText.replace("[&#8230;]", "...");

const DownloadSlider: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [slides, setSlides] = useState<Slide[]>([]);

  const feedUrl = useMemo(() => feedUrlForMandant(UserStore.mandantId), []);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const parser = new Parser();
        const feed = await parser.parseURL(feedUrl); // Achtung: CORS – ggf. via Proxy laden
        const items: Slide[] =
          feed.items?.map((item) => ({
            title: item.title ?? "",
            description: item.content ?? "",
            button: "Mehr erfahren",
            image: "", // optionales Bildfeld aus Feed nicht genutzt
            link: item.link ?? "",
          })) ?? [];

        if (!mounted) return;
        setSlides(items);
        setLoading(false);
      } catch (e) {
        console.warn("Error while loading feed — using fallback", e);
        if (!mounted) return;
        setSlides(fallbackSlides(UserStore.mandantId));
        setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [feedUrl]);

  if (loading) return null;

  return (
    <AnimatedSlider
      autoplay={4000}
      infinite
      className="download"
      slideClassName="slider-content slider-small"
    >
      {slides.map((slide, idx) => {
        return (
          <div
            key={idx}
            className="inner"
            style={{
              color: "black",
              backgroundSize: "cover",
              width: "100%",
              height: "100%",
            }}
          >
            <h2 className="slider_title">{slide.title}</h2>
            <p
              className="slider_body"
              style={{ maxHeight: slide.button !== "" ? 120 : 190 }}
            >
              {sanitize(slide.description)}
            </p>
            {slide.link && (
              <a href={slide.link} target="_blank" rel="noopener noreferrer">
                <button className="mehr">{slide.button}</button>
              </a>
            )}
          </div>
        );
      })}
    </AnimatedSlider>
  );
};

export default DownloadSlider;
